module.exports = __webpack_public_path__ + "static/img/bg-fr.a5e150c8.png";